module.exports = __webpack_public_path__ + "img/st-quotes.4890f11b.jpg";